import getDeviceType from 'lib/utils/get-device-type'
import I18n from 'lib/i18n'

export const getSharePayload = (type, shareUrl, title, appId = '') => {
  const isDesktopDevice = getDeviceType() && getDeviceType().device.type === 'desktop'
  const emailLink = `mailto:?subject=${I18n.t('courses.show.mail_subject')}&body=${I18n.t(
    'courses.show.mail_body'
  )} ${shareUrl}`
  const whatsAppLink = isDesktopDevice
    ? `https://web.whatsapp.com/send?text=${I18n.t('courses.show.mail_body')} ${encodeURIComponent(shareUrl)}`
    : `https://api.whatsapp.com/send?text=${I18n.t('courses.show.mail_body')} ${encodeURIComponent(shareUrl)}`
  const facebookMessengerShareLink = isDesktopDevice
    ? `https://www.facebook.com/dialog/send?app_id=${appId}&link=${encodeURIComponent(
        shareUrl
      )}&redirect_uri=${encodeURIComponent(shareUrl)}`
    : `fb-messenger://share?link=${encodeURIComponent(shareUrl)}&app_id=${appId}`
  switch (type) {
    case 'facebook':
      return [
        `https://www.facebook.com/dialog/feed?app_id=${appId}&display=popup&link=${encodeURIComponent(shareUrl)}`,
        'share-facebook',
        'toolbar=0,status=0,width=600,height=436'
      ]
    case 'twitter':
      return [
        'https://twitter.com/share?url=' + encodeURIComponent(shareUrl) + '&text=' + encodeURIComponent(title),
        'share-linkedin',
        'toolbar=0,status=0,width=600,height=436'
      ]
    case 'linkedin':
      return [
        'https://www.linkedin.com/cws/share?url=' + encodeURIComponent(shareUrl),
        'share-linkedin',
        'toolbar=0,status=0,width=600,height=436'
      ]
    case 'messenger':
      return [facebookMessengerShareLink, 'share-messenger', 'toolbar=0,status=0,width=600,height=436']
    case 'whatsapp':
      return [whatsAppLink, 'share-messenger', 'toolbar=0,status=0,width=600,height=436']
    case 'mail':
      return [emailLink, '_self']
    default:
      break
  }
}
